import { FlexBox, SPACING } from "@joonapp/web-shared"
import { Typography } from "@joonapp/web-shared"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import useMediaQuery from "../../../hooks/useMediaQuery"
import useOnboardContext, { ChildStep } from "../../../hooks/useOnboardContext"
import { QuestionnaireType } from "../../../types"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"
import ChevronBackButton from "../../buttons/ChevronBackButton"
import Primary3DButton from "../../buttons/Primary3DButton"
import OnboardingPageContentWrapper from "../onboardingPageContentWrapper/OnboardingPageContentWrapper"

interface Props {
  childName: string
  onConfirm: () => void
  questionnaireType?: QuestionnaireType
}

function QuestionnaireDisclaimer({
  childName,
  onConfirm,
  questionnaireType = QuestionnaireType.ONBOARDING,
}: Props) {
  const { setChildStep } = useOnboardContext()
  const [isLoading, setIsLoading] = useState(true)
  const { t } = useTranslation()

  const isSmallMobile = useMediaQuery("(max-width: 500px)")
  const isOnboarding = questionnaireType === QuestionnaireType.ONBOARDING

  return (
    <OnboardingPageContentWrapper
      backgroundImageOnDesktop="url(/images/background/cloud-bg.png)"
      paddingTop={SPACING.space14}
      style={{ position: "relative" }}
      removeTopBottomMargin={!isOnboarding}
    >
      <FlexBox
        direction="column"
        align="center"
        gap={SPACING.space3}
        style={{ marginBottom: SPACING.space6 }}
      >
        {isOnboarding && (
          <ChevronBackButton
            onClick={() => setChildStep(ChildStep.ChildInfo)}
          />
        )}
        <img
          src="/images/gifs/onboarding-clipboard-gif.gif"
          alt="Questionnaire"
          style={{
            width: isSmallMobile ? "160px" : "200px",
            height: isSmallMobile ? "auto" : "200px",
            opacity: isLoading ? 0 : 1,
            transition: "opacity 0.1s ease-in-out",
          }}
          onLoad={() => setIsLoading(false)}
        />
        <Typography variant="h2Serif" textAlign="center">
          {t("QUESTIONNAIRE_DISCLAIMER_TITLE", { childName })}
        </Typography>
        <Typography variant="body" textAlign="center" style={{ width: "90%" }}>
          {t("QUESTIONNAIRE_DISCLAIMER_SUBTITLE")}
        </Typography>
      </FlexBox>
      <FlexBox direction="column" align="center" gap={SPACING.space3}>
        <Typography
          variant="bodySmall"
          textAlign="center"
          style={{ width: "70%" }}
        >
          {t("ONBOARDING_ANSWERS_PRIVATE")}
        </Typography>
        <Primary3DButton
          fullWidth
          text={t("ONBOARDING_CONTINUE")}
          onClick={() => {
            onConfirm()
            trackAnalyticEvent(ANALYTIC_EVENTS.START_CHILD_ONBOARDING_SURVEY)
          }}
        />
      </FlexBox>
    </OnboardingPageContentWrapper>
  )
}

export default QuestionnaireDisclaimer
